import React from "react";
import ReusableHelmet from "../helmet/helmet";

const organizationLd = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "Tenders Club",
  url: "https://tenders.club",
  logo: "https://tenders.club/logo512.png",
  contactPoint: {
    "@type": "ContactPoint",
    email: "info@tenders.club",
    contactType: "customer service",
  },
};

const websiteLd = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  name: "Tenders Club",
  url: "https://tenders.club",
};

export default function DefaultStructuredData() {
  return (
    <ReusableHelmet
      section="Tenders Club"
      tabTitle="Public Procurement Intelligence"
      description="Find, analyse and win public procurement tenders across Europe with Tenders Club."
      pageTitle="Tenders Club - Public Procurement Intelligence"
      jsonLd={[organizationLd, websiteLd]}
    />
  );
}
